// @flow
export { default } from './QuoteContent';



// WEBPACK FOOTER //
// ./src/components/quote/QuoteContent/index.js